import { render, staticRenderFns } from "./Vladiators.vue?vue&type=template&id=6cb7b448&"
import script from "./Vladiators.vue?vue&type=script&lang=js&"
export * from "./Vladiators.vue?vue&type=script&lang=js&"
import style0 from "./Vladiators.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports